import DriveIcon from './DriveIcon'

export default DriveIcon
